import angular from 'angular';
import ContentLoaderService from './contentLoader.service';

let contentLoaderModule = angular.module('contentLoader', []).service('contentLoaderService', ContentLoaderService);

export default contentLoaderModule;



// WEBPACK FOOTER //
// ./app/common/contentLoader/contentLoader.js